const useCurrencyLogic = () => {
  const apiRoute = "currencies";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "name",
      label: "Currency Name",
      type: "text",
      isRequired: true,
      err: "Currency Name is required",
    },
    {
      name: "code",
      label: "Currency Code",
      type: "text",
      isRequired: true,
      err: "Currency Code is required",
    },
    {
      name: "symbol",
      label: "Currency Symbol",
      type: "text",
      isRequired: true,
      err: "Currency Symbol is required",
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;

  ///Add,Delete,Edit Roles
  const addRoles = [admin];
  const deleteRoles = [admin];
  const editRoles = [admin];

  const getPromises = (temp) => {
    return [];
  };

  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    getPromises,
    onlyForm,
  };
};
export default useCurrencyLogic;
